import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/da865b71-49ee-41a9-86ec-f32dabd3effb";
export const REGISTER_URL = "https://a.ntrk2.com/36b4d06f-d19c-4dd4-a8db-2033e368a3bc";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export * from "./codes";
export * from "./context";
export const DOWNLOAD_URL = "https://ezvip.loadprkw2a.com/download?openExternalBrowser=1&id=nk2b5kgsytx087t";
